/* eslint-disable @typescript-eslint/no-throw-literal */
import {
  action,
  observable,
} from 'mobx';
import {
  isUndefined,
} from 'lodash';
import {
  EditorState, convertFromRaw,
} from 'draft-js';
import {
  RequestStatus,
} from 'mobx-store';
import {
  ReleaseNotesDTO,
} from '../../screens/releaseNotesScreen/DTOs/releaseNotesDTO';
import {
  releaseNotesPath,
  singleReleaseNotesIdPath,
} from '../../axios/releaseNotesRequests';
import Connections from '../../connections';
import {
  ReleaseNotesStoreInterface,
} from '../storeInterfaces/releaseNotesInterface';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  DefaultLanguage,
} from '../../constants/languages';

export class ReleaseNotesStore implements ReleaseNotesStoreInterface {
  @observable currentReleaseNotes: ReleaseNotesDTO;

  @observable releasesNotesList: ReleaseNotesDTO[] = [];

  @observable totalNumberOfReleaseNotes = -1;

  @observable getReleasesNotesListRequestStatus: RequestStatus = RequestStatus.IDLE;

  @observable createOrUpdateStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getPaginatedReleasesNotesList(pageNumber: number, pageSize: number): Promise<void> {
    try {
      this.getReleasesNotesListRequestStatus = RequestStatus.LOADING;
      const params = {
        pageNumber,
        pageSize,
      };
      const response = await Connections.wadiDeglaAxios.httpGet(releaseNotesPath, {
        params,
      });

      this.releasesNotesList = response?.data.releasesNotes;
      this.totalNumberOfReleaseNotes = response?.data.count;
      this.getReleasesNotesListRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getReleasesNotesListRequestStatus = RequestStatus.FAILED;
      console.log(error);
      throw Promise.reject(error);
    }
  }

  @action
  public async getReleaseNotesById(notesId: number, langCode: string = DefaultLanguage): Promise<void> {
    try {
      this.createOrUpdateStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(singleReleaseNotesIdPath(notesId), getHeader(langCode));

      this.currentReleaseNotes = response?.data;
      if (this.currentReleaseNotes.body) {
        this.currentReleaseNotes.body = EditorState.createWithContent(
          convertFromRaw(JSON.parse(this.currentReleaseNotes.body as string)),
        );
      }

      this.createOrUpdateStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.createOrUpdateStatus = RequestStatus.FAILED;
      console.log(error);
      throw Promise.reject(error);
    }
  }

  @action
  public async createNewReleaseNotes(
    releaseNotes: ReleaseNotesDTO, langCode: string = DefaultLanguage,
  ): Promise<number> {
    try {
      this.createOrUpdateStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpPost(releaseNotesPath, releaseNotes, getHeader(langCode));
      this.createOrUpdateStatus = RequestStatus.SUCCESS;
      return response.data.newReleaseNotesId;
    } catch (error) {
      this.createOrUpdateStatus = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  @action
  public async updateReleaseNotesById(
    releaseNotesId: number, updatedReleaseNotes: ReleaseNotesDTO, langCode: string = DefaultLanguage, index?: number,
  ): Promise<void> {
    try {
      await Connections.wadiDeglaAxios.httpPut(
        singleReleaseNotesIdPath(releaseNotesId), updatedReleaseNotes, getHeader(langCode),
      );
      if (isUndefined(index)) {
        this.currentReleaseNotes = updatedReleaseNotes;
      } else {
        this.releasesNotesList[index] = updatedReleaseNotes;
      }
    } catch (error) {
      console.log(error);
      throw Promise.reject(error);
    }
  }
}
